if (!window.IWCProductGalleryCore) {
  window.IWCProductGalleryCore = {
    parseTokens(value) {
      return String(value || "")
        .split("|")
        .map((token) => token.trim())
        .filter(Boolean);
    },

    getResolvedMediaIndexSet(resolvedMediaIndexes) {
      if (!Array.isArray(resolvedMediaIndexes)) return null;
      return new Set(resolvedMediaIndexes);
    },

    matchesOptionTokens(slide, selectedOptionTokens = []) {
      const requiredTokens = this.parseTokens(slide.dataset.optionTokens);
      if (!requiredTokens.length) return true;

      const selectedTokens = new Set(selectedOptionTokens);
      return requiredTokens.every((token) => selectedTokens.has(token));
    },

    isMediaVisible(slide, exactCount, selectedFabric, selectedFamily, selectedOptionTokens) {
      const token = slide.dataset.fabricToken || "";
      const family = slide.dataset.fabricFamily || "";
      let visible = false;

      if (!selectedFabric) {
        visible = true;
      } else if (!token) {
        visible = true;
      } else if (token === selectedFabric) {
        visible = true;
      } else if (exactCount === 0 && family && family === selectedFamily) {
        visible = true;
      }

      return visible && this.matchesOptionTokens(slide, selectedOptionTokens);
    },

    setSlideVisible(slide, visible) {
      slide.hidden = !visible;
      slide.style.display = visible ? "" : "none";
    },

    renderSlides(wrapper, allSlides, visibleSlides) {
      if (!wrapper) return;

      allSlides.forEach((slide) => {
        if (!visibleSlides.includes(slide) && slide.parentElement === wrapper) {
          slide.remove();
        }
      });

      visibleSlides.forEach((slide) => {
        wrapper.appendChild(slide);
      });
    },

    filterPairedSlides({
      slides,
      thumbnailSlides = [],
      mainWrapper,
      thumbnailWrapper,
      selectedFabric = "",
      selectedFamily = "",
      selectedOptionTokens = [],
      resolvedMediaIndexes = null,
      fallbackToAll = false,
      indexThumbnails = false,
    }) {
      const visibleSlides = [];
      const visibleThumbnailSlides = [];
      const resolvedMediaIndexSet = this.getResolvedMediaIndexSet(resolvedMediaIndexes);
      const exactCount = slides.filter((slide) => {
        return slide.dataset.fabricToken === selectedFabric && this.matchesOptionTokens(slide, selectedOptionTokens);
      }).length;
      let visibleIndex = 0;

      slides.forEach((slide) => {
        const thumbnailSlide = thumbnailSlides.find((thumb) => thumb.dataset.mediaIndex === slide.dataset.mediaIndex);
        const visible = resolvedMediaIndexSet
          ? resolvedMediaIndexSet.has(slide.dataset.mediaIndex)
          : this.isMediaVisible(slide, exactCount, selectedFabric, selectedFamily, selectedOptionTokens);

        this.setSlideVisible(slide, visible);
        if (thumbnailSlide) {
          this.setSlideVisible(thumbnailSlide, visible);
        }

        if (visible) {
          slide.dataset.index = String(visibleIndex);
          visibleSlides.push(slide);
          if (thumbnailSlide) {
            if (indexThumbnails) {
              thumbnailSlide.dataset.index = String(visibleIndex);
            }
            visibleThumbnailSlides.push(thumbnailSlide);
          }
          visibleIndex += 1;
        }
      });

      if (fallbackToAll && resolvedMediaIndexSet == null && !visibleSlides.length) {
        slides.forEach((slide, index) => {
          const thumbnailSlide = thumbnailSlides.find((thumb) => thumb.dataset.mediaIndex === slide.dataset.mediaIndex);
          this.setSlideVisible(slide, true);
          slide.dataset.index = String(index);
          visibleSlides.push(slide);
          if (thumbnailSlide) {
            this.setSlideVisible(thumbnailSlide, true);
            if (indexThumbnails) {
              thumbnailSlide.dataset.index = String(index);
            }
            visibleThumbnailSlides.push(thumbnailSlide);
          }
        });
      }

      this.renderSlides(mainWrapper, slides, visibleSlides);
      this.renderSlides(thumbnailWrapper, thumbnailSlides, visibleThumbnailSlides);

      return {
        visibleSlides,
        visibleThumbnailSlides,
        visibleCount: visibleSlides.length,
      };
    },

    createThumbnailSwiper(container, options = {}) {
      if (!container) return undefined;

      return new Swiper(container, {
        direction: "horizontal",
        loop: false,
        grabCursor: false,
        speed: 350,
        slidesPerView: 5,
        spaceBetween: 4,
        watchSlidesProgress: true,
        ...options,
      });
    },

    getSlideIndexForMedia(swiper, slides, mediaIndex) {
      if (!swiper || mediaIndex == null) return -1;

      const targetSlide = slides.find((slide) => {
        return slide.dataset.mediaIndex === String(mediaIndex) && !slide.hidden;
      });
      if (!targetSlide) return -1;

      return Array.from(swiper.slides).indexOf(targetSlide);
    },

    syncActiveThumbnail({ swiper, thumbnailSwiper, thumbnailSlides, buttonSelector }) {
      if (!swiper) return;

      const activeSlide = swiper.slides[swiper.activeIndex];
      const activeMediaIndex = activeSlide?.dataset.mediaIndex;
      if (activeMediaIndex == null) return;

      thumbnailSlides.forEach((slide) => {
        const active = slide.dataset.mediaIndex === activeMediaIndex;
        const button = slide.querySelector(buttonSelector);
        slide.classList.toggle("is-active", active);
        if (button) {
          button.setAttribute("aria-current", active ? "true" : "false");
        }
      });

      if (thumbnailSwiper) {
        const activeThumbnailIndex = Array.from(thumbnailSwiper.slides).findIndex((slide) => {
          return slide.dataset.mediaIndex === activeMediaIndex && !slide.hidden;
        });
        if (activeThumbnailIndex >= 0) {
          thumbnailSwiper.slideTo(activeThumbnailIndex);
        }
      }
    },
  };
}
